import { Box, Skeleton, Stack } from "@skailer-com/uikit";
import { twMerge } from "tailwind-merge";

export interface ApplicantListItemSkeletonProps {
  isCompact?: boolean;
}

export const ApplicantListItemSkeleton = ({
  isCompact = false,
}: ApplicantListItemSkeletonProps) => {
  return (
    <Stack direction={"horizontal"}>
      <Box className={twMerge("shrink-0", isCompact ? "w-full" : "w-1/3")}>
        <Box className={"h-[5.75rem] px-6 py-3.5"}>
          <Stack direction={"horizontal"} gap={"smd"} items={"start"}>
            <Skeleton className={"mt-1 h-9 w-9 shrink-0 rounded-sm"} />
            <Stack gap={"xs"} className={"w-full pt-1"}>
              <Skeleton className={"h-4 w-2/5 rounded-xs"} />
              <Skeleton className={"h-4 w-3/5 rounded-xs"} />
              <Skeleton className={"h-4 w-1/3 rounded-xs"} />
            </Stack>
          </Stack>
        </Box>
      </Box>
      {!isCompact && (
        <div className={"grid grid-cols-2 px-6 w-full gap-md"}>
          <Stack gap={"sm"} className={"w-full pt-3"}>
            <Skeleton className={"h-4 w-1/2 rounded-xs"} />
            <Skeleton className={"h-4 w-4/5 rounded-xs"} />
          </Stack>
          <Stack gap={"xs"} className={"w-full py-3"}>
            <Skeleton className={"h-4 w-3/5 rounded-xs"} />
            <Skeleton className={"h-4 w-2/5 rounded-xs"} />
          </Stack>
        </div>
      )}
    </Stack>
  );
};
